
<template>
  <div @click.self="closeModal" class="modalContainer">
    <div class="modalWrapper">
      <div @click="closeModal" class="close" tabindex="0" aria-label="Close modal" role="button">
        <img src="@/assets/icons/close.svg" alt="close" />
      </div>
      <div class="upsell-container">

        <div 
          v-for="upsell in orderData?.order_level_pick_list_data?.pick_lists" 
          :key="upsell"
        >
          <h3 class="upsellHeader" ref="upsellDropdown">
            {{ upsell.prompt }}
          </h3>
          <div class="upsell-wrapper"> 
            <div
              v-for="item in upsell.pick_list_items"
              :key="item.itemid"
              class="upsellItem"
            >
              <img
                v-if="checkIfImageIsVisible"
                class="upsellItemImage"
                :src="item.image_urls.standard"
                :alt="item.name"
                loading="lazy"
              />

              <RecommendedItem
                :orderData="orderData" 
                :pickListItem="item"
                :isPriceVisible="checkIfPriceVisible(item.baseprice)"
                @itemClicked="handleItemClicked"
              />

            </div>
          </div>
        </div>
      </div>
      <div class="buttonWrapper">
        <button class="buttonClose" @click="closeModal">Close</button>
      </div>
    
    </div>

    <transition name="slide">
      <WithAddons
        v-if="withAddonsModalIsOpen"
        @closeModal="toggleWithAddonsModal"
        :itemData="itemData"
        :normalizedAddons="normalizedAddons"
        :mode="itemModalMode"
        :editItemData="editItemData"
      />
    </transition>


    <LoaderView v-if="showLoader" :showLoader="showLoader" />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import menusApi from '@/api/menusApi'
import WithAddons from '@/components/Modals/ItemModals/WithAddons.vue'
import normalizeAddons from '@/mixins/normalizeAddons.js'
import LoaderView from '@/components/Loaders/LoaderView.vue'
import modalMixins from '@/mixins/modalMixins.js'
import formattingMixins from '@/mixins/formattingMixins'
import menuItemImageVisibility from '@/mixins/menuItemImageVisibility'
import RecommendedItem from '@/components/Elements/RecommendedItem.vue'

export default {
  mixins: [modalMixins, formattingMixins, menuItemImageVisibility, normalizeAddons],
  data() {
    return {
      withAddonsModalIsOpen: false,
      itemData: null,
      normalizedAddons: null,
      itemModalMode: 'add',
      editItemData: null,
      showLoader: false,
    }
  },
  components: {
    WithAddons,
    LoaderView,
    RecommendedItem
  },
  computed: {
    ...mapState(['orderData', 'branding', 'selectedHour', 'selectedDay']),
  },
  methods: {
    ...mapMutations([
      'SET_TOASTER',
      'SET_COOKIES'
    ]),
    closeModal() {
      this.$emit('closeModal')
    },
    checkIfPriceVisible(price) {
      if ('hide_price_if_zero' in this.branding?.display_options) {
        if (price == 0 && this.branding?.display_options?.hide_price_if_zero) {
          return false
        }
      }
      return true
    },
    openUpsellItem(item, category) {
      this.getItemData(item, category, 'add')
    },

    toggleWithAddonsModal() {
      this.withAddonsModalIsOpen = !this.withAddonsModalIsOpen
    },

    getItemData(item, category, mode) {
      this.showLoader = true
      if (mode == 'edit') {
        this.editItemData = item
        this.editItemData.menu_id = item.menu_id
      } else {
        this.itemModalMode = 'add'
      }
      this.showLoader = true
      let storeId = localStorage.getItem('selectedStoreId')
      if (storeId.includes(' ')) {
        storeId = storeId.replace(' ', '%20')
      }
      let time = this.selectedHour.hour == 'ASAP' ? this.selectedHour.asapTime : this.selectedHour.hour
      let payload = {
        ready_ts: this.selectedDay.date + ' ' + time,
      }
      menusApi
        .getItem(storeId, item.menu_id, category.category_id, item.item_id, payload)
        .then((response) => {
          this.itemData = response.data.data
          this.itemData.menu_id = item.menu_id
          this.normalizedAddons = this.normalizeAddons(response.data.data)
          this.showLoader = false
          this.SET_COOKIES(response.data.cookies)
          this.toggleWithAddonsModal()
        })
        .catch((error) => {
          console.log(error)
          this.showLoader = false
          this.showLoader = false
          let toasterData = {
            show: true,
            message: 'Something went wrong. Please try again later',
          }
          this.SET_TOASTER(toasterData)
        })
    },
    handleItemClicked(item) {
      this.openUpsellItem({ item_id: item.itemid, menu_id: item.menuid }, { category_id: item.catid })
    }
  },
}
</script>

<style scoped>

.upsell-container {
  overflow-y: scroll;
}
.upsell-wrapper {
  padding-right: 10px;
}
.upsellItemImage {
  width: 72px;
  height: 72px;
  object-fit: cover;
  aspect-ratio: 16/9;
  border-radius: 5px;
}

.upsellItem {
  display: flex;
  gap: 15px;
  border: 1px solid var(--border-color);
  border-radius: 7px;
  height: auto;
  overflow: hidden;
  padding: 20px;
  margin-bottom:  10px;
}

.upsellItem:hover{
  background: #F4F4F4;
}

.upsellHeader {
  padding-bottom: 20px;
  font-size: calc(22px * var(--header-font-size-multiplier));
  position: relative;
}

.upsellItem:last-child {
  margin-bottom: 30px;
}

.modalWrapper {
  max-width: 400px;
  width: 92vw;
  background-color: var(--background-color);
  border-radius: 5px;
  /* padding: 20px; */
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 600px;
  margin: 0px 10px;
  position: relative;
  overflow: hidden;
}
.upsell-container::-webkit-scrollbar {
  width: 8px;
}
.upsell-container::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 5px;
}
.upsell-container::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
.upsell-container::-webkit-scrollbar-track {
  margin: 50px 0 30px 0;
}

.buttonWrapper {
  position: sticky;
  bottom: -20px;
  margin-top: auto;
  background-color: var(--background-color);
  padding: 10px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}
.buttonClose {
  width: 100%;
}

</style>